// src/features/rooms/pages/RoomDetailsPage/components/RoomMetadataCard.jsx
import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  Box,
  Typography,
  Card,
  CardContent,
  Stack,
  Divider,
} from '@mui/material';
import StaffMemberById from '../../../../../components/common/StaffMemberById';
import LocalizedDateDistance from '../../../../../i18n/LocalizedDateDistance';

export default function RoomMetadataCard({ room }) {
  const { t } = useTranslation(['rooms', 'common']);

  return (
    <Card sx={{ height: "100%", minWidth: "250px" }}>
      <CardContent>
        <Typography variant="h6" gutterBottom>
          {t('rooms:metadata')}
        </Typography>
        <Divider sx={{ my: 2 }} />

        <Stack spacing={2}>
          <Box>
            <Typography variant="caption" color="text.secondary">
              {t('rooms:labels.created')}
            </Typography>
            <Typography variant="body2">
              <LocalizedDateDistance date={room.created_at} />
            </Typography>
          </Box>

          <Box>
            <Typography variant="caption" color="text.secondary">
              {t('rooms:labels.created_by')}
            </Typography>
            <StaffMemberById staffId={room.created_by} />
          </Box>

          {!room.is_active && (
            <>
              <Box>
                <Typography variant="caption" color="text.secondary">
                  {t('rooms:labels.deactivated_by')}
                </Typography>
                <StaffMemberById staffId={room.deactivated_by} />
              </Box>

              {room.deactivation_reason && (
                <Box>
                  <Typography variant="caption" color="text.secondary">
                    {t('rooms:labels.deactivation_reason')}
                  </Typography>
                  <Typography variant="body2">
                    {room.deactivation_reason}
                  </Typography>
                </Box>
              )}

              {room.deactivated_at && (
                <Box>
                  <Typography variant="caption" color="text.secondary">
                    {t('common:labels.deactivated_at')}
                  </Typography>
                  <Typography variant="body2">
                    <LocalizedDateDistance date={room.deactivated_at} />
                  </Typography>
                </Box>
              )}
            </>
          )}
        </Stack>
      </CardContent>
    </Card>
  );
}